// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #eef3f8;
  font-family: 'Segoe UI', sans-serif;
  padding: 1rem;
}

.login-card {
  display: flex;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-width: 900px;
  width: 100%;
}

.login-left {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  flex: 1 1;
  padding: 3rem;
  text-align: center;
}

.login-left img.login-logo {
  width: 80px;
  margin-bottom: 1rem;
}

.login-left h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.login-left p {
  font-size: 1.1rem;
}

.login-right {
  flex: 1 1;
  padding: 3rem;
}

.login-right h2 {
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
}

.login-right form {
  display: flex;
  flex-direction: column;
}

.login-right input[type="email"],
.login-right input[type="password"],
.login-right input[type="text"] {
  padding: 12px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 15px;
  margin-bottom: 1rem;
}

.password-field {
  position: relative;

}

.password-field input {
  width: 92%;
  padding-right: 40px;
}

.password-field span {
  position: absolute;
  right: 12px;
  top: 37%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
  font-size: 18px;
}

.remember {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 14px;
}

.login-error {
  background: #ffe6e6;
  color: #c00;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  text-align: center;
}

.login-button {
  background-color: #007bff;
  color: white;
  padding: 12px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s ease;
}

.login-button:hover {
  background-color: #0056b3;
}

@media (max-width: 768px) {
  .login-card {
    flex-direction: column;
  }

  .login-left, .login-right {
    padding: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".login-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: #eef3f8;\n  font-family: 'Segoe UI', sans-serif;\n  padding: 1rem;\n}\n\n.login-card {\n  display: flex;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  max-width: 900px;\n  width: 100%;\n}\n\n.login-left {\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  color: white;\n  flex: 1;\n  padding: 3rem;\n  text-align: center;\n}\n\n.login-left img.login-logo {\n  width: 80px;\n  margin-bottom: 1rem;\n}\n\n.login-left h1 {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n}\n\n.login-left p {\n  font-size: 1.1rem;\n}\n\n.login-right {\n  flex: 1;\n  padding: 3rem;\n}\n\n.login-right h2 {\n  margin-bottom: 2rem;\n  text-align: center;\n  color: #333;\n}\n\n.login-right form {\n  display: flex;\n  flex-direction: column;\n}\n\n.login-right input[type=\"email\"],\n.login-right input[type=\"password\"],\n.login-right input[type=\"text\"] {\n  padding: 12px 14px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 15px;\n  margin-bottom: 1rem;\n}\n\n.password-field {\n  position: relative;\n\n}\n\n.password-field input {\n  width: 92%;\n  padding-right: 40px;\n}\n\n.password-field span {\n  position: absolute;\n  right: 12px;\n  top: 37%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #888;\n  font-size: 18px;\n}\n\n.remember {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n  font-size: 14px;\n}\n\n.login-error {\n  background: #ffe6e6;\n  color: #c00;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.login-button {\n  background-color: #007bff;\n  color: white;\n  padding: 12px;\n  font-size: 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: 0.3s ease;\n}\n\n.login-button:hover {\n  background-color: #0056b3;\n}\n\n@media (max-width: 768px) {\n  .login-card {\n    flex-direction: column;\n  }\n\n  .login-left, .login-right {\n    padding: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
